const FormTextArea = ({
  name,
  label,
  value,
  errorMessage,
  onChange,
  className = "",
  ...props
}) => {
  return (
    <div className={`textarea-container ${className}`}>
      <label htmlFor={name}>{label}</label>
      <textarea type="text" name={name} value={value} onChange={(e) => onChange(e)} {...props} />

      <div className="error-msg">{errorMessage}</div>
    </div>
  );
};

export default FormTextArea;